// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__f8Pms","spin":"styles_spin__iRPfZ"};